'use client';

import { createContext, useContext } from 'react';

/** 未接入时间门控的页面维持原行为。 */
export const YearLowestPriceBadgeContext = createContext(true);

export function useYearLowestPriceBadgeEnabled() {
  return useContext(YearLowestPriceBadgeContext);
}
